import React, {useEffect, useRef} from "react";
import styled, { ThemeProvider } from "styled-components";
import { lightTheme } from "./Themes";
import { Design, Develope, Backend, Devops } from "./subComponents/AllSvgs";
import LogoComponent from "./subComponents/LogoComponent";
import SocialIcons from "./subComponents/SocialIcons";
import PowerButton from "./subComponents/PowerButton";
import ParticleComponent from "./subComponents/ParticleComponent";
import BigTitle from "./subComponents/BigTitle";
import { motion } from "framer-motion";
import {CenterMahi} from "./subComponents/AllSvgs";


const Profile = styled(motion.div)`
  position:absolute;
  top:7px;
  right:1rem;
  @media (max-width: 720px) {
    position: absolute;
}`
const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  height: 300vh;
  width:auto;
  position: relative;
  display: flex;
  align-items: center;
`;

const Main = styled(motion.div)`
border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  background-color: ${(props) => props.theme.body};
  padding: 2rem;
  width: 30vw;
  height: fit-content;

  z-index: 3;
  line-height: 1.5;

  font-family: "Ubuntu Mono", monospace;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor:pointer;
  margin-right:50px;
  &:hover {
    color: ${(props) => props.theme.body};
    background-color: ${(props) => props.theme.text};
  }
  @media (max-width: 720px) {
    display:inline-block;
    width:60%;
}
}
`;
const Title = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(1em + 1vw);

  ${Main}:hover & {
    & > * {
      fill: ${(props) => props.theme.body};
    }
  }
  & > *:first-child {
    margin-right: 1rem;
  }
`;

const Description = styled.div`
  color: ${(props) => props.theme.text};
  font-size: calc(0.6em + 1vw);
  padding: 0.5rem 0;

  strong {
    margin-bottom: 1rem;
    text-transform: uppercase;
  }
  ul,
  p {
    margin-left: 2rem;
  }

  ${Main}:hover & {
    color: ${(props) => props.theme.body};
  }
`;

  const Container = styled.div`
  position: fixed;
  top: 12rem;
  left: calc(10rem + 15vw);
  height: 40vh;
  display: flex;
  color:white;
  `;

const MainContainer = styled.div`
@media (max-width: 770px) {
  position: relative;
  top:5%;
}  
@media (max-height: 887px) and (max-width: 770px) {
  position:relative;
  top:40%!important;
}  

`;

const SkillContainer = styled(motion.div)`

`;
const container = {
  hidden: {opacity: 0},
  show:{
    opacity:1,

    transition:{
      type:'spring',
      staggerChildren:0.6,
      duration: 1,
    }
  }
}

const profile = {
  hidden: {opacity: 0},
  show:{
    opacity:1,
    initial :{transform:"scale(0)"},
    animate:{scale:[0,1,1.5,1]},
    transition:{
      delay:0.4,
      type:'spring',
      staggerChildren:0.6,
      duration: 1,
    }
  }
}

function MySkillPage() {
  const ref = useRef(null);
  // const profile = useRef(null);
  useEffect(() => {
    let element = ref.current;

    const rotate = () =>{
      element.style.transform = `translateX(${-window.pageYOffset}px)`
      // profile.current.style.transform = `rotate(` + -window.pageYOffset + `deg)`
    }

    window.addEventListener('scroll', rotate);

    return () => window.removeEventListener('scroll', rotate);


    }, [])


  return (
    <ThemeProvider theme={lightTheme}>
       <SkillContainer 
    variants={container}
    initial='hidden'
    animate='show'
    exit={{
      opacity:0, transition:{duration: 0.5}
    }}>
      <Box>
        <LogoComponent theme="light" />
        <PowerButton />
        <SocialIcons theme="light" />
        <Profile variants={profile}>
        <CenterMahi  width={100} height={120} fill='currentColor'/>
        </Profile>
        <ParticleComponent theme="light"/>
        <MainContainer  className="">
        <Container ref={ref} className="row">
        <Main  variants={container} className="col col-lg-4 col-md-12 col-sm-12 ">
          <Title>
            <Design width={40} height={40} /> Designer
          </Title>
          
          <Description>
            <strong>I LIKE TO DESIGN</strong>
            <ul>
              <li>Web Design</li>
              <li>Mobile Apps</li>
            </ul>
          </Description>
          <Description>
            <strong>Tools</strong>  
            <ul>
              <li>Figma</li>
            </ul>
          </Description>
        </Main>
        <Main variants={container} className="col col-lg-4 col-md-12 col-sm-12  ">
          <Title>
            <Develope width={40} height={40} /> Frontend Developer
          </Title>
          
          <Description>
            <strong>SKILLS</strong>
            <p>
              Html, Css, Js, ReactJs, NextJs, Redux, Sass, Bootstrap, MUI, Chakra UI, Recoil
              etc.
            </p>
          </Description>
          <Description>
            <strong>Tools</strong>
            <p>VScode, Codepen etc.</p>
          </Description>
        </Main>
        <Main variants={container} className="col col-lg-4 col-md-12 col-sm-12 ">
          <Title>
            <Backend width={40} height={40} /> Backend Developer
          </Title>
         
          <Description>
            <strong>SKILLS</strong>
            <p>NodeJs, ExpressJs, MongoDb</p>
          </Description>
          <Description>
            <strong>Tools</strong>  
            <p>VScode, Postman, Mongo Atlas, Swagger</p>
          </Description>
        </Main>
        <Main variants={container} className="col col-lg-4 col-md-12 col-sm-12  ">
          <Title>
            <Devops width={40} height={40} /> Devops
          </Title>
          
          <Description>
            <strong>SKILLS</strong>
            <p>
              Git, GiHub, Docker, Docker Compose, Kubernetes, Slack
            </p>
          </Description>
          <Description>
            <strong>Tools</strong>
            <p>VScode, Github Desktop, Docker Desktop, etc.</p>
          </Description>
        </Main>

        </Container>
        </MainContainer>        
        <BigTitle text="SKILLS" top="80%" left="30%"/>
      </Box>
      </SkillContainer>
    </ThemeProvider>
  );
}

export default MySkillPage;
